import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { connect } from "react-redux"
import { Field, reduxForm, FormSection } from 'redux-form'

import queryString from 'query-string';
import { store, history } from '../store/configureStore'
import { push } from 'react-router-redux';

import { CLIENT_LOGIN, CLIENT_PAGE_UNLOADED } from '../constants/actionTypes';
import Svg from '../components/Svg';
import agent from '../agent'
import AMLogo from '../assets/images/audition-magic-favicon.png';
import Aux from './AuxContainer'

import ClientLoginForm from '../components/ClientLoginForm'

const Header = ({clientDetails}) => (
<section id="brand-logo" className="section-brand-logo section">
  <div className="row">
  <div className="small-12 small-centered column text-center">
  	<img className="am-logo" src={AMLogo} alt="" />
    <p className="top-title">Audition Magic Project Client Page</p>
  </div>
  </div>
</section>
) 

class ClientLoginContainer extends Component {
  // componentWillUnmount() {
  // 	this.props.onUnload();
  // }
  
  componentWillMount() {
		const clientToken = localStorage.getItem('jwt') &&  JSON.parse(localStorage.getItem('jwt'))
		if (clientToken && clientToken.token) {
			// agent.setToken(token);
			history.push('/projects')
		}
		// this.props.onLoad(clientToken)
	}

  onSubmit = values => {
  	const { email, password } = values
  	if (email && password) {
  		return this.props.login(email, password);	
  	}
  }

	render() {
		return (
			<Aux>
				<Header />

				<section id="client-login" className="section-client-login gray-bg section">
					<div className="row">
						<div className="small-12 small-centered column text-center">
							<Link to="/" className="back-button">
								<span className="fa-stack fa-lg">
								  <i className="fa fa-circle fa-stack-2x"></i>
								  <i className="fa fa-angle-left fa-stack-1x fa-inverse"></i>
								</span>
							</Link>

							<h2>I am the client</h2>
							<h6 className="subheader">Log in</h6>
							<div className="row">
								<div className="small-12 medium-6 large-4 small-centered column">

									<ClientLoginForm onSubmit={this.onSubmit} errors={this.props.errors} />

								</div>
							</div>
						</div>
					</div>
				</section>
			</Aux>
		)
	}
}


const mapStateToProps = state => ({
	...state.auth,
	...state.common,
})

const mapDispatchToProps = dispatch => ({
	login: (email, password) => dispatch({
		type: CLIENT_LOGIN, 
		payload: agent.Client.login(email.toLowerCase(), password)
	}),
	onUnload: () => {
		dispatch({ type: CLIENT_PAGE_UNLOADED })
	}
})

export default connect(mapStateToProps, mapDispatchToProps)(ClientLoginContainer)



// WEBPACK FOOTER //
// ./src/containers/ClientLoginContainer.js